import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { navigateToSameWindow } from '../libs/history';
import { asset } from '../services/assetResolverService';
import { Col } from './grid/Col';
import { Row } from './grid/Row';
import { FC } from 'react';

const SiteSwitcherButton: FC<any> = (props) => {
  return (
    <Col
      grow={false}
      className={cx(
        'rio-site-switch--button rio-pointer',
        props.className,
        props.active ? 'rio-site-switch--button-selected' : ''
      )}
      onClick={navigateToSameWindow.bind(null, props.href)}
    >
      <img
        src={asset(
          props.active ? '/images/site/switcher/logo_black_small.png' : '/images/site/switcher/logo_white_small.png'
        )}
      />
      <span>{props.label}</span>
    </Col>
  );
};

type TSiteSwitcherBarProps = {
  game: 'wowretail' | 'wowera' | 'wowclassic';
  className?: string;
};

export const SiteSwitcherBar: FC<TSiteSwitcherBarProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Row
      gutter={'xxx-small'}
      verticalAlign="center"
      className={cx(props.className)}
      style={{ height: 30 }}
      wrap={false}
    >
      <SiteSwitcherButton
        label={t('common:game-tags.wowretail')}
        active={props.game === 'wowretail'}
        href={RIO_ALL_SITES.wowretail.external_url}
      />
      <SiteSwitcherButton
        label={t('common:game-tags.wowera')}
        active={props.game === 'wowera'}
        href={RIO_ALL_SITES.wowera.external_url}
      />
      <SiteSwitcherButton
        label={t('common:game-tags.wowclassic')}
        active={props.game === 'wowclassic'}
        href={RIO_ALL_SITES.wowclassic.external_url}
      />
    </Row>
  );
};
